class PageHeaderSection extends HTMLElement {
  constructor() {
    super();

    this.isSticky = this.dataset.sticky === "true";
    this.isStickyAlways = this.dataset.stickyAlways === "true";
    this.isTransparent = this.dataset.transparent === "true";
    this.isAlwaysMobileMenu = this.dataset.alwaysMobileMenu === "true";

    this.classBodyAlwaysMobileMenu = "mobile-nav";

    this.header = document.querySelector(".page-header");
    this.desktopMenuTrigger = document.querySelector(
      ".wt-header__sticky-menu-trigger",
    );
    this.desktopMenuBar = document.querySelector(".wt-drawer--nav");

    this.enabledClass = "sticky-enabled";
    this.showClass = "sticky-show";
    this.desktopHeaderWithMenuBarClass = "page-header--sticky-show-menubar-lg";
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.disableStickyHeader();
  }

  enableStickyHeader() {
    if (!this.header) {
      console.error("Header element not found for enabling sticky header");
      return;
    }

    document.body.classList.add("page-header-sticky");

    let prevScrollpos = window.pageYOffset;

    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
    const isMenuBarOpen = () =>
      this.header.classList.contains(this.desktopHeaderWithMenuBarClass);
    const isHeaderWithDesktopNav =
      !document.body.classList.contains("mobile-nav");
    const allLLevelsLinks =
      this.desktopMenuBar?.querySelectorAll("a[data-menu-level]");
    const onlyLevel1Links = this.desktopMenuBar?.querySelectorAll(
      "a[data-menu-level='1']",
    );

    const calculateNavbarTopMargin = () => {
      // Try multiple selectors to find the header and navbar elements
      const header = document.querySelector("#header") || 
                     document.querySelector(".page-header") || 
                     document.querySelector("header");
      
      const navbar = document.querySelector("#wt-drawer-nav") || 
                     document.querySelector(".wt-drawer--nav") || 
                     this.desktopMenuBar;
      
      if (!header || !navbar) {
        // Only log this warning in development, not in production
        if (window.Shopify && window.Shopify.designMode) {
          console.warn("Header or navbar elements not found for margin calculation");
        }
        return 0;
      }

      // Use requestAnimationFrame to separate read and write operations
      // to prevent forced reflow
      return new Promise(resolve => {
        // First frame: read DOM values
        requestAnimationFrame(() => {
          // Read phase - get all measurements at once
          const headerHeight = header.offsetHeight;
          const navbarHeight = navbar.offsetHeight;
          
          let marginTop = 0;
          if (navbarHeight > headerHeight) {
            marginTop = headerHeight - navbarHeight;
          } else {
            marginTop = Math.abs(navbarHeight - headerHeight);
          }
          
          // Second frame: apply DOM updates
          requestAnimationFrame(() => {
            // Write phase - update the DOM
            navbar.style.setProperty("--top-margin", `${marginTop}px`);
            resolve(marginTop);
          });
        });
      });
    };

    // Call asynchronously to prevent blocking
    try {
      const result = calculateNavbarTopMargin();
      if (result && typeof result.catch === 'function') {
        result.catch(err => console.error('Error calculating navbar margin:', err));
      }
    } catch (err) {
      console.error('Error calculating navbar margin:', err);
    }

    const stickyHeader = {
      show: () => {
        // Update state first
        stickyHeader.visible = true;
        
        // Batch DOM updates with requestAnimationFrame
        requestAnimationFrame(() => {
          if (this.header) this.header.classList.add(this.showClass);
          stickyHeader.handleBehavior();
          // Call asynchronously to prevent blocking
          try {
            const result = calculateNavbarTopMargin();
            if (result && typeof result.catch === 'function') {
              result.catch(err => console.error('Error calculating navbar margin:', err));
            }
          } catch (err) {
            console.error('Error calculating navbar margin:', err);
          }
        });
      },
      hide: () => {
        // Update state first
        stickyHeader.visible = false;
        
        // Batch DOM updates with requestAnimationFrame
        requestAnimationFrame(() => {
          if (this.header) this.header.classList.remove(this.showClass);
          stickyHeader.handleBehavior();
        });
      },
      enable: () => {
        // Update state first
        stickyHeader.enabled = true;
        
        // Batch DOM updates with requestAnimationFrame
        requestAnimationFrame(() => {
          if (this.header) this.header.classList.add(this.enabledClass);
          stickyHeader.handleBehavior();
        });
      },
      disable: () => {
        // Update state first
        stickyHeader.enabled = false;
        
        // Batch DOM updates with requestAnimationFrame
        requestAnimationFrame(() => {
          if (this.header) this.header.classList.remove(this.enabledClass, this.showClass);
          stickyHeader.handleBehavior();
        });
      },
      enabled: false,
      visible: true,
      handleBehavior: () => {
        if (isHeaderWithDesktopNav && isDesktop && this.header) {
          stickyHeader.log();
          if (!isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "-1");
          }
          if (isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "0");
          }
          if (!stickyHeader.enabled) {
            setTabindex(onlyLevel1Links, "0");
            if (this.desktopMenuTrigger)
              setTabindex([this.desktopMenuTrigger], "-1");
          } else if (this.desktopMenuTrigger)
            setTabindex([this.desktopMenuTrigger], "0");
        }
      },
      log: () => {},
    };

    // Throttle and optimize the scroll handler to reduce reflows
    let ticking = false;
    this.scrollHandler = () => {
      // Skip if we're already processing a frame
      if (ticking) return;
      
      ticking = true;
      
      // Use requestAnimationFrame to batch DOM operations
      requestAnimationFrame(() => {
        const currentScrollPos = window.pageYOffset;
        
        // Determine if we should show or hide the header based on scroll direction
        const shouldShow = this.isStickyAlways || prevScrollpos > currentScrollPos;
        
        // Update state
        if (shouldShow) {
          stickyHeader.show();
        } else {
          stickyHeader.hide();
        }
        
        // Store current position for next comparison
        prevScrollpos = currentScrollPos;
        
        // Allow the next frame to be processed
        ticking = false;
      });
    };

    window.addEventListener("scroll", this.scrollHandler);

    // Store the event handler reference for proper cleanup
    this.menuTriggerHandler = (e) => {
      e.preventDefault();
      
      // Batch DOM reads
      const isMenuOpen = this.desktopMenuBar?.classList.contains("wt-drawer--nav-show");
      
      // Schedule visual updates in the next animation frame
      requestAnimationFrame(() => {
        // Batch DOM writes
        this.desktopMenuBar?.classList.toggle("wt-drawer--nav-show");
        this.desktopMenuTrigger?.classList.toggle("wt-header__sticky-menu-trigger--active");
        this.header?.classList.toggle(this.desktopHeaderWithMenuBarClass);
        
        // Handle behavior after visual updates
        stickyHeader.handleBehavior();
      });
    };
    
    // Add event listener with proper reference for later removal
    this.desktopMenuTrigger?.addEventListener("click", this.menuTriggerHandler);

    const sentinel = document.querySelector(".sticky-header__threshold");
    
    // Optimize the IntersectionObserver callback
    const handleStickySentinel = (entries) => {
      // Only process the most recent entry to avoid multiple state changes
      const entry = entries[entries.length - 1];
      
      // Debounce state changes to avoid rapid toggling
      if (this._stickySentinelTimeout) {
        clearTimeout(this._stickySentinelTimeout);
      }
      
      this._stickySentinelTimeout = setTimeout(() => {
        // Update state based on intersection
        if (entry.isIntersecting) {
          stickyHeader.disable();
        } else {
          stickyHeader.enable();
        }
      }, 10); // Small timeout to debounce multiple rapid changes
    };

    // Use options to optimize observer performance
    const observerOptions = {
      threshold: [0.0, 0.1], // Trigger at 0% and 10% visibility
      rootMargin: '0px'      // No margin
    };

    this.stickyHeaderObserver = new IntersectionObserver(handleStickySentinel, observerOptions);
    
    // Only observe if the sentinel element exists
    if (sentinel) {
      this.stickyHeaderObserver.observe(sentinel);
    } else {
      console.warn("Sticky header sentinel element not found");
    }
  }

  disableStickyHeader() {
    // Use requestAnimationFrame for DOM updates
    requestAnimationFrame(() => {
      if (this.header) {
        // Batch DOM writes - remove classes added by sticky header
        this.header.classList.remove(
          this.enabledClass,
          this.showClass,
          this.desktopHeaderWithMenuBarClass,
        );
        document.body.classList.remove("page-header-sticky");
        this.desktopMenuBar?.classList.remove("wt-drawer--nav-show");
        this.desktopMenuTrigger?.classList.remove(
          "wt-header__sticky-menu-trigger--active",
        );
      }
    });

    // Clear any pending timeouts
    if (this._stickySentinelTimeout) {
      clearTimeout(this._stickySentinelTimeout);
      this._stickySentinelTimeout = null;
    }

    // Remove the scroll event listener
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
      this.scrollHandler = null;
    }
    
    // Remove menu trigger event listener
    if (this.menuTriggerHandler && this.desktopMenuTrigger) {
      this.desktopMenuTrigger.removeEventListener("click", this.menuTriggerHandler);
      this.menuTriggerHandler = null;
    }

    // Disconnect the IntersectionObserver
    if (this.stickyHeaderObserver) {
      this.stickyHeaderObserver.disconnect();
      this.stickyHeaderObserver = null;
    }
  }

  init() {
    if (this.isAlwaysMobileMenu) {
      document.body.classList.add(this.classBodyAlwaysMobileMenu);
    } else {
      document.body.classList.remove(this.classBodyAlwaysMobileMenu);
    }

    if (this.isSticky) {
      this.enableStickyHeader();
    } else {
      this.disableStickyHeader();
    }
  }
}

customElements.define("page-header", PageHeaderSection);
